<template>
    <div class="notificationRow pointer" :class="{ new: !item.readOn }" @click="navigate">
        <div>
            <localized-text localizedKey="Ricevuta nuova prenotazione per l'escursione " text="Ricevuta nuova prenotazione per l'escursione "></localized-text> {{item.villageTrip.name}}
        </div>
        <div>
            <localized-text localizedKey="Utente " text="Utente "></localized-text> {{item.customer.name}}
        </div>
    </div>
</template>
<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { BackendNotificationClient } from '@/services/Services';

@Options({})
export default class backendNotificationVillageTripBooked extends Vue {

    @Prop() item: OM.BackendNotificationVillageTripBooked;

    navigate(){
        BackendNotificationClient.setRead(this.item.identifier);
        this.$emit('close');
        this.$router.push('/villageTripBookRequests');
    }

}

</script>
